/**
 * @generated SignedSource<<94b1961e0bf474d0ad07e1075ba051a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillGoalsReportByWeekFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dateRanges: ReadonlyArray<DateRangeInput>;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  passedSkillGoal: number;
  siteIds?: ReadonlyArray<string> | null | undefined;
};
export type DateRangeInput = {
  fromDate: any;
  toDate: any;
};
export type DashboardGoalMetByWeekQuery$variables = {
  filter: StudentSkillGoalsReportByWeekFilterInput;
};
export type DashboardGoalMetByWeekQuery$data = {
  readonly studentSkillGoalsReportByWeek: ReadonlyArray<{
    readonly dateRange: {
      readonly fromDate: any;
      readonly toDate: any;
    };
    readonly percentageStudentsPassedGoal: number;
  }>;
};
export type DashboardGoalMetByWeekQuery = {
  response: DashboardGoalMetByWeekQuery$data;
  variables: DashboardGoalMetByWeekQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "GoalByWeeks",
    "kind": "LinkedField",
    "name": "studentSkillGoalsReportByWeek",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentageStudentsPassedGoal",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGoalMetByWeekQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGoalMetByWeekQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9f1eab0304a24eb0e2765d9986765e5f",
    "id": null,
    "metadata": {},
    "name": "DashboardGoalMetByWeekQuery",
    "operationKind": "query",
    "text": "query DashboardGoalMetByWeekQuery(\n  $filter: StudentSkillGoalsReportByWeekFilterInput!\n) {\n  studentSkillGoalsReportByWeek(filter: $filter) {\n    dateRange {\n      fromDate\n      toDate\n    }\n    percentageStudentsPassedGoal\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8b12102354cfad5ce2cee20e88f9a0e";

export default node;
